import PropTypes from 'prop-types';
import { useState } from 'react';

import { useAppSelector } from '@/redux';
import { getSelectedValue } from '@/utils/categUtils';

import Accordion from '@/components/common/Accordion';
import CheckboxBlocFilterContainer from '@/components/categ/filters/CheckboxBlocFilterContainer';
import PriceFilter from '@/components/categ/filters/PriceFilter';
import { FILTERS_TYPE } from '@/constants/categ';

const FilterBox = ({
  t, filter, min, max, onChange,
  defaultMin, defaultMax, selectedFiltersInfos, open: initialOpen
}) => {
  const [opened, setOpened] = useState(initialOpen);
  const { locale, currencyISO: currency } = useAppSelector(({ root }) => root.storeConf);

  const accordionContent = () => {
    let content;
    switch (filter.type) {
      case FILTERS_TYPE.PRICE:
        content = (
          <PriceFilter
            t={t}
            locale={locale}
            currency={currency}
            onChange={onChange}
            sliderDefaultCursorMin={Math.max(defaultMin || min, min)}
            sliderDefaultCursorMax={Math.min(defaultMax || max, max)}
            min={min}
            max={max}
          />
        );
        break;
      case FILTERS_TYPE.CHECKBOX:
      case FILTERS_TYPE.BLOC:
        content = (
          <CheckboxBlocFilterContainer
            t={t}
            filter={filter}
            onChange={onChange}
            selectedValue={getSelectedValue(filter, selectedFiltersInfos)}
          />
        );
        break;
      default:
        content = null;
        break;
    }

    return content;
  };

  return (
    <Accordion
      id={`${filter.nameId}-filter`}
      label={filter.name}
      open={opened}
      showArrow={false}
      onClick={() => setOpened(!opened)}
    >
      {accordionContent()}
    </Accordion>
  );
};

FilterBox.propTypes = {
  t: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
  defaultMin: PropTypes.number,
  defaultMax: PropTypes.number,
  selectedFiltersInfos: PropTypes.array,
  open: PropTypes.bool
};

export default FilterBox;
